import React from 'react';
import { Search } from 'lucide-react';

const JobHeaderSearch = ({ query, setQuery }) => {
    return (
        <div className="flex items-center flex-1 bg-[#F3F4F8] border border-gray-200 rounded-lg px-3 py-2.5 gap-2 focus-within:border-[#3F57E0] focus-within:ring-1 focus-within:ring-[#3F57E0] transition-all">
            <Search className="w-4 h-4 text-gray-400 flex-shrink-0" />
            <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search by job title, company or keyword…"
                className="flex-1 text-sm text-gray-700 bg-transparent outline-none placeholder-gray-400"
            />
        </div>
    );
};

export default JobHeaderSearch;
